// removed by extract-text-webpack-plugin
module.exports = {"container":"_1egRXDo2OYBWmA4peagDjw","close":"_3nAWKM_4A17tHcsOnViuCC","subheader":"_1xc7KGrofx55PO8YyyQLI9","error":"_2hCDB6jifibYODtpGNH7y","textarea":"_1B1ik4_W5OG3hpPoQ5HiW3","button":"_2RKuE3dDw81bNFR809UoQm"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bf3a1c3","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/shared/InstantInvite/InstantInviteModal.less
// module id = knzp
// module chunks = 1